// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf_inner_partts h2 {
  font-size: 24px;
  color: #1c1c1c;
}

.upload-btn-wrapper121 {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 300px;
  height: 200px;
  border: 2px solid #004aad;
  color: gray;
  background-color: white;
  border-radius: 8px;
}

.upload-btn-wrapper121 .btn {
  padding: 8px 20px;

  font-size: 20px;
  font-weight: bold;
}

.upload-btn-wrapper121 input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}

.pdf_inner_partts .upload-btn-wrapper121 .btn {
  width: 100%;
  padding: 0px;
}

.upload-btn-wrapper121 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.right_banner_banner_cnt .pdf_inner_partts h2 {
  margin-bottom: 20px;
}
.some_content {
  padding-top: 30px;
}

.some_content h2 {
  text-align: left;
}
.pdf_box {
  margin-top: 40px;
}

.pdf_innner_box {
  margin: 0 -10px;
  display: flex;
  flex-wrap: wrap;
}

.pdf_inner_inner_box {
  padding: 0 10px;
  width: calc(100% / 4);
  margin-bottom: 30px;
  position: relative;
}

.cross {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background-color: #f00;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: -2px;
  top: -10px;
  color: #fff;
  cursor: pointer;
}

.button_group .yes {
  background-color: #f00;
  padding: 10px 30px;
  margin: 0px 20px;
  border: 0px;
}
.button_group .no {
  background-color: #1c1c1c;
  padding: 10px 30px;
  margin: 0px 20px;
  border: 0px;
}
.pdf_boxi {
  position: relative;
  box-shadow: 0 0 10px rgb(0 0 0 / 50%);
  height: 295px;
  border-radius: 10px;
  border: 1px solid #ccc;
  overflow: hidden;
  border: 1px solid #004aad;
}

.price_field {
  margin-top: 40px;
}

.price_field label {
  font-size: 24px;
  color: #1c1c1c;
}

.up_qr_code {
  margin-top: 30px;
}

.pdf_boxi .react-pdf__Document .react-pdf__Page {
  width: 100%;
  min-width: 100% !important;
  height: 295px;
  min-height: 295px !important;
  object-fit: cover;
}

.pdf_boxi .react-pdf__Document .react-pdf__Page .react-pdf__Page__canvas {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
}
/* .pdf_box{
      border: 1px solid #004aad;
  } */

.pdf_banner img {
  width: 100%;
  height: auto;
}

.pdf_content {
  margin-top: 20px;
  padding: 0 20px;
}

.pdf_price_img,
.scan_code {
  margin-bottom: 10px;
}

.right_banner_banner_cnt .certificate_terms h2 {
  font-size: 14px;
  padding-top: 0px;
  padding-bottom: 10px;
  margin-bottom: 0px;
}

.certificate_terms p {
  font-size: 12px;
  line-height: 14px;
  margin-bottom: 20px;
  color: #000;
}

.certificate_terms h3 {
  font-size: 14px;
  color: #000;
  text-transform: uppercase;
  margin-top: 20px;
  margin-bottom: 10px;
}

.certificate_terms .go_online p {
  font-size: 13px;
  font-weight: 600;
  color: #000;
  margin: 5px 0;
}

.certificate_terms .foot_cont p {
  font-size: 12px;
  margin-top: 10px;
  text-align: center;
  line-height: 16px;
  color: #000;
}

.pdf_inner_inner_box1 {
  padding: 0 20px;
}

.padding_top30px {
  padding-top: 60px;
  text-align: center;
}

.certificate_terms.inner_termmmms h2 {
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 30px;
}

.certificate_terms.inner_termmmms p {
  font-size: 15px;
  line-height: 24px;
  color: #000;
}

.certificate_terms.inner_termmmms h3 {
  margin-top: 30px;
  font-size: 26px;
  font-weight: 700;
  color: #000;
  margin-bottom: 20px;
}

.go_online.online_go p {
  font-size: 16px;
}

.foot_cont {
  max-width: 700px;
  width: 100%;
  margin: 25px auto 0;
}
.scan_code.code_scan {
  margin-top: 30px;
}
.pdf_logo_img.logo_pdf {
  margin-top: 120px;
}
.foot_cont p {
  font-size: 16px;
  text-align: center;
  line-height: 26px;
  color: #000;
  font-weight: 600;
}
@media screen and (max-width: 1199px) {
  .pdf_inner_inner_box {
    width: calc(100% / 2);
  }
}

@media screen and (max-width: 480px) {
  .pdf_inner_inner_box {
    width: calc(100% / 1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/travelcertificates/print/print.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;;EAEjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,aAAa;EACb,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;;KAEK;;AAEL;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".pdf_inner_partts h2 {\n  font-size: 24px;\n  color: #1c1c1c;\n}\n\n.upload-btn-wrapper121 {\n  position: relative;\n  overflow: hidden;\n  display: inline-block;\n  width: 300px;\n  height: 200px;\n  border: 2px solid #004aad;\n  color: gray;\n  background-color: white;\n  border-radius: 8px;\n}\n\n.upload-btn-wrapper121 .btn {\n  padding: 8px 20px;\n\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.upload-btn-wrapper121 input[type=\"file\"] {\n  font-size: 100px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.pdf_inner_partts .upload-btn-wrapper121 .btn {\n  width: 100%;\n  padding: 0px;\n}\n\n.upload-btn-wrapper121 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.right_banner_banner_cnt .pdf_inner_partts h2 {\n  margin-bottom: 20px;\n}\n.some_content {\n  padding-top: 30px;\n}\n\n.some_content h2 {\n  text-align: left;\n}\n.pdf_box {\n  margin-top: 40px;\n}\n\n.pdf_innner_box {\n  margin: 0 -10px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.pdf_inner_inner_box {\n  padding: 0 10px;\n  width: calc(100% / 4);\n  margin-bottom: 30px;\n  position: relative;\n}\n\n.cross {\n  width: 30px;\n  height: 30px;\n  border-radius: 100%;\n  background-color: #f00;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  right: -2px;\n  top: -10px;\n  color: #fff;\n  cursor: pointer;\n}\n\n.button_group .yes {\n  background-color: #f00;\n  padding: 10px 30px;\n  margin: 0px 20px;\n  border: 0px;\n}\n.button_group .no {\n  background-color: #1c1c1c;\n  padding: 10px 30px;\n  margin: 0px 20px;\n  border: 0px;\n}\n.pdf_boxi {\n  position: relative;\n  box-shadow: 0 0 10px rgb(0 0 0 / 50%);\n  height: 295px;\n  border-radius: 10px;\n  border: 1px solid #ccc;\n  overflow: hidden;\n  border: 1px solid #004aad;\n}\n\n.price_field {\n  margin-top: 40px;\n}\n\n.price_field label {\n  font-size: 24px;\n  color: #1c1c1c;\n}\n\n.up_qr_code {\n  margin-top: 30px;\n}\n\n.pdf_boxi .react-pdf__Document .react-pdf__Page {\n  width: 100%;\n  min-width: 100% !important;\n  height: 295px;\n  min-height: 295px !important;\n  object-fit: cover;\n}\n\n.pdf_boxi .react-pdf__Document .react-pdf__Page .react-pdf__Page__canvas {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover;\n}\n/* .pdf_box{\n      border: 1px solid #004aad;\n  } */\n\n.pdf_banner img {\n  width: 100%;\n  height: auto;\n}\n\n.pdf_content {\n  margin-top: 20px;\n  padding: 0 20px;\n}\n\n.pdf_price_img,\n.scan_code {\n  margin-bottom: 10px;\n}\n\n.right_banner_banner_cnt .certificate_terms h2 {\n  font-size: 14px;\n  padding-top: 0px;\n  padding-bottom: 10px;\n  margin-bottom: 0px;\n}\n\n.certificate_terms p {\n  font-size: 12px;\n  line-height: 14px;\n  margin-bottom: 20px;\n  color: #000;\n}\n\n.certificate_terms h3 {\n  font-size: 14px;\n  color: #000;\n  text-transform: uppercase;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.certificate_terms .go_online p {\n  font-size: 13px;\n  font-weight: 600;\n  color: #000;\n  margin: 5px 0;\n}\n\n.certificate_terms .foot_cont p {\n  font-size: 12px;\n  margin-top: 10px;\n  text-align: center;\n  line-height: 16px;\n  color: #000;\n}\n\n.pdf_inner_inner_box1 {\n  padding: 0 20px;\n}\n\n.padding_top30px {\n  padding-top: 60px;\n  text-align: center;\n}\n\n.certificate_terms.inner_termmmms h2 {\n  font-weight: 600;\n  font-size: 22px;\n  margin-bottom: 30px;\n}\n\n.certificate_terms.inner_termmmms p {\n  font-size: 15px;\n  line-height: 24px;\n  color: #000;\n}\n\n.certificate_terms.inner_termmmms h3 {\n  margin-top: 30px;\n  font-size: 26px;\n  font-weight: 700;\n  color: #000;\n  margin-bottom: 20px;\n}\n\n.go_online.online_go p {\n  font-size: 16px;\n}\n\n.foot_cont {\n  max-width: 700px;\n  width: 100%;\n  margin: 25px auto 0;\n}\n.scan_code.code_scan {\n  margin-top: 30px;\n}\n.pdf_logo_img.logo_pdf {\n  margin-top: 120px;\n}\n.foot_cont p {\n  font-size: 16px;\n  text-align: center;\n  line-height: 26px;\n  color: #000;\n  font-weight: 600;\n}\n@media screen and (max-width: 1199px) {\n  .pdf_inner_inner_box {\n    width: calc(100% / 2);\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .pdf_inner_inner_box {\n    width: calc(100% / 1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
